import { MedicalPaOrder } from "../../../data-model/medicalPaOrdersModel";

export const checkRpaError = (data: MedicalPaOrder) => {
  const authEntries = data?.auth_on_file?.auth_entries;
  const authOnFileStatusExists = data.status?.auth_on_file;

  if (authOnFileStatusExists === undefined && authEntries === undefined) {
    return true;
  }
  return false;
};

export const checkStatus = (data: MedicalPaOrder) => {
  if (data.status?.auth_on_file) {
    return data.status?.auth_on_file?.status;
  }
};

export const getErrorType = (data: MedicalPaOrder) => {
  if (data.status?.auth_on_file) {
    return data.status?.auth_on_file?.error_type;
  }
};
